export interface Slide {
  step: number;
  emoji: string;
  title: string;
  subtitle: string;
  bullets: string[];
  accent?: string;
  bg: string;
}

// Saskatoon / real estate images
export const IMAGES = {
  skyline1: "https://images.unsplash.com/photo-1758310999518-4126c4a1bf5f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
  skyline2: "https://images.unsplash.com/photo-1758649989991-2a152980ae65?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
  bridge:   "https://images.unsplash.com/photo-1758565940999-68bb93af9c29?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
  house1:   "https://images.unsplash.com/photo-1591474200742-8e512e6f98f8?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
  house2:   "https://images.unsplash.com/photo-1668911494509-14baf3b42fda?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
  house3:   "https://images.unsplash.com/photo-1668911494481-1643ee3e1235?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
  house4:   "https://images.unsplash.com/photo-1668911495278-487418f8f72d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
  house5:   "https://images.unsplash.com/photo-1577915589301-09000ae0d072?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
  house6:   "https://images.unsplash.com/photo-1727668576352-2721389d41c7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
  keys:     "https://images.unsplash.com/photo-1643804926339-e94f0a655185?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
  keysHand: "https://images.unsplash.com/photo-1729855637715-99192904aac5?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
  keysNew:  "https://images.unsplash.com/photo-1723094796813-9648187efc38?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
  handover: "https://images.unsplash.com/photo-1733244766159-f58f4184fd38?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
  docs:     "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
  tablet:   "https://images.unsplash.com/photo-1664463760781-f159dfe3af30?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
  headshot: "/images/agent_headshot.jpg",
};

export const buyerSlides: Slide[] = [
  {
    step: 0,
    emoji: "🏡",
    title: "YOUR BUYER'S JOURNEY",
    subtitle: "Saskatoon Real Estate",
    bullets: ["From first meeting to Possession Day — here's everything that happens when we work together to find your perfect home in Saskatoon, SK."],
    accent: "Cover",
    bg: IMAGES.skyline1,
  },
  {
    step: 1,
    emoji: "📝",
    title: "Let's Make It Official",
    subtitle: "Step 1 — Agency & FINTRAC",
    bullets: [
      "Sign the Buyer's Brokerage Agreement — I work exclusively FOR you",
      "Complete FINTRAC identity verification (required by Canadian law)",
      "Sign ancillary documents to get the ball rolling",
    ],
    bg: IMAGES.docs,
  },
  {
    step: 2,
    emoji: "💰",
    title: "Get Pre-Approved",
    subtitle: "Step 2 — Mortgage Pre-Approval",
    bullets: [
      "Pay stubs, T4s & Notice of Assessment",
      "Employment letter & 90-day bank statements",
      "Credit consent & photo ID",
      "Proof of down payment",
    ],
    accent: "Don't know any mortgage brokers? No problem — I'll refer you to some of the best in the city! 🏦",
    bg: IMAGES.tablet,
  },
  {
    step: 3,
    emoji: "🔍",
    title: "The Hunt Is On!",
    subtitle: "Step 3 — Property Viewings",
    bullets: [
      "We tour Saskatoon neighbourhoods together",
      "Right location, right layout, right feeling",
      "No rush — we go until it feels like home",
    ],
    bg: IMAGES.house3,
  },
  {
    step: 4,
    emoji: "📄",
    title: "Writing the Offer",
    subtitle: "Step 4 — Offer & Conditions",
    bullets: [
      "🔒 Financing condition",
      "🔒 Home inspection condition",
      "🔒 PCDS (Property Condition Disclosure) review",
      "🔒 Title review condition",
      "🔒 City of Saskatoon PID (Property Information Disclosure) — confirms any deficiencies or unauthorized additions on title",
      "🔒 Estoppel Certificate condition (if Condominium property)",
      "💵 Once accepted — deposit is provided to the real estate brokerage to move forward",
    ],
    accent: "🎉 Offer accepted? Your deposit is due to the brokerage — this shows you're serious and moves the deal forward!",
    bg: IMAGES.house1,
  },
  {
    step: 5,
    emoji: "🤝",
    title: "Negotiations",
    subtitle: "Step 5 — Getting You the Best Deal",
    bullets: [
      "Price, inclusions, and possession date",
      "Counter-offers handled strategically",
      "Your goals — my priority",
    ],
    bg: IMAGES.headshot,
  },
  {
    step: 6,
    emoji: "⚖️",
    title: "Hire Your Lawyer",
    subtitle: "Step 6 — Legal Representation",
    bullets: [
      "Real estate lawyer handles title transfer",
      "Title insurance & legal compliance",
      "SK buyer legal fees: ~$1,500 – $2,500+",
      "(plus disbursements & applicable taxes)",
    ],
    accent: "Don't know a real estate lawyer? No problem — I'll refer you to one of the best in the city! ⚖️  |  Avg. SK fee: $1,500–$2,500+",
    bg: IMAGES.headshot,
  },
  {
    step: 7,
    emoji: "🔎",
    title: "Home Inspection",
    subtitle: "Step 7 — No Surprises!",
    bullets: [
      "Licensed inspector — roof to foundation",
      "Electrical, plumbing & structural review",
      "HVAC systems & insulation check",
      "Full written report provided",
    ],
    bg: IMAGES.house2,
  },
  {
    step: 8,
    emoji: "📋",
    title: "Document Review",
    subtitle: "Step 8 — Full Due Diligence",
    bullets: [
      "📌 Parcel ID — confirms the legal land description & title",
      "📋 PCDS — seller's written disclosure of all known property conditions",
      "🏛️ City of Saskatoon PID (Property Information Disclosure) — ordered from the City to reveal any outstanding deficiencies, unpermitted additions, or bylaw violations on the property",
      "🏢 Estoppel Certificate — required for Condominium properties; confirms condo fees, reserve fund status, bylaws & any outstanding levies",
    ],
    accent: "No surprises. Full transparency. ✅",
    bg: IMAGES.house4,
  },
  {
    step: 9,
    emoji: "✅",
    title: "Conditions Removed",
    subtitle: "Step 9 — The Deal is FIRM",
    bullets: [
      "Financing confirmed ✅",
      "Inspection reviewed & satisfied ✅",
      "PCDS accepted ✅",
      "All conditions waived in writing — deal is binding!",
    ],
    bg: IMAGES.house5,
  },
  {
    step: 10,
    emoji: "🗂️",
    title: "Conveyancing",
    subtitle: "Step 10 — File Sent to Your Lawyer",
    bullets: [
      "Lawyer prepares all closing documents",
      "Title transfer coordinated with seller's lawyer",
      "Final adjustments & statement of adjustments prepared",
    ],
    bg: IMAGES.house6,
  },
  {
    step: 11,
    emoji: "🎉",
    title: "POSSESSION DAY!",
    subtitle: "Step 11 — Welcome Home! 🔑",
    bullets: [
      "Keys in hand. New chapter begins.",
      "Your Saskatoon home is officially YOURS!",
      "Ready to start your journey? DM me today!",
    ],
    accent: "🥂 Congratulations!",
    bg: IMAGES.handover,
  },
];

export const sellerSlides: Slide[] = [
  {
    step: 0,
    emoji: "💰",
    title: "YOUR SELLER'S JOURNEY",
    subtitle: "Saskatoon Real Estate",
    bullets: ["From first meeting to final closing — here's everything that happens when we list and sell your Saskatoon home together."],
    accent: "Cover",
    bg: IMAGES.skyline2,
  },
  {
    step: 1,
    emoji: "📝",
    title: "Let's Make It Official",
    subtitle: "Step 1 — Agency & FINTRAC",
    bullets: [
      "Sign the Seller's Brokerage Agreement — full market exposure",
      "Complete FINTRAC identity verification (mandatory Canadian law)",
      "Sign ancillary documents to authorize your listing",
    ],
    bg: IMAGES.docs,
  },
  {
    step: 2,
    emoji: "📊",
    title: "Know Your Numbers",
    subtitle: "Step 2 — Comparative Market Analysis",
    bullets: [
      "Recent comparable sales in your area",
      "Active competition on the Saskatoon market",
      "Strategic pricing = more showings + stronger offers",
    ],
    accent: "Priced right = SOLD faster! 🎯",
    bg: IMAGES.bridge,
  },
  {
    step: 3,
    emoji: "📋",
    title: "Complete Your PCDS",
    subtitle: "Step 3 — Property Disclosure",
    bullets: [
      "Property Condition Disclosure Statement",
      "Honest written disclosure of known home conditions",
      "Protects you legally & builds buyer confidence",
    ],
    bg: IMAGES.tablet,
  },
  {
    step: 4,
    emoji: "📸",
    title: "We Go LIVE!",
    subtitle: "Step 4 — Marketing Your Home",
    bullets: [
      "Professional photography & compelling listing copy",
      "Full MLS exposure across Saskatoon",
      "Social media marketing & open houses",
      "Your home's moment to shine! ✨",
    ],
    bg: IMAGES.house1,
  },
  {
    step: 5,
    emoji: "🔑",
    title: "Showings & Interest",
    subtitle: "Step 5 — Buyer Activity",
    bullets: [
      "Qualified buyers tour your property",
      "Feedback gathered after every showing",
      "Market activity monitored in real time",
      "You're kept informed every step of the way",
    ],
    bg: IMAGES.house2,
  },
  {
    step: 6,
    emoji: "📄",
    title: "Reviewing the Offer",
    subtitle: "Step 6 — Analyzing Your Offer",
    bullets: [
      "Price, possession date & inclusions reviewed",
      "Buyer's financing & inspection conditions",
      "PCDS conditions & title review",
      "I walk you through every single line",
    ],
    bg: IMAGES.house3,
  },
  {
    step: 7,
    emoji: "🤝",
    title: "Negotiations",
    subtitle: "Step 7 — Fighting for Your Bottom Line",
    bullets: [
      "Accept, counter-offer, or reject",
      "Price, possession date & inclusions negotiated",
      "I advocate fiercely on your behalf",
    ],
    accent: "Your goals — my priority.",
    bg: IMAGES.headshot,
  },
  {
    step: 8,
    emoji: "⚖️",
    title: "Hire Your Lawyer",
    subtitle: "Step 8 — Legal Representation",
    bullets: [
      "Lawyer prepares title transfer documents",
      "Mortgage discharge coordinated with lender",
      "SK seller legal fees: ~$1,500 – $2,500+",
      "(plus disbursements & applicable taxes)",
    ],
    accent: "Don't know a real estate lawyer? No problem — I'll refer you to one of the best in the city! ⚖️  |  Avg. SK fee: $1,500–$2,500+",
    bg: IMAGES.headshot,
  },
  {
    step: 9,
    emoji: "🔎",
    title: "Buyer's Home Inspection",
    subtitle: "Step 9 — Transparency Wins",
    bullets: [
      "Buyer arranges a licensed inspector",
      "You provide reasonable property access",
      "Any concerns navigated calmly & professionally",
    ],
    bg: IMAGES.house4,
  },
  {
    step: 10,
    emoji: "✅",
    title: "Documents Confirmed & Conditions Removed",
    subtitle: "Step 10 — FIRM & BINDING",
    bullets: [
      "City of Saskatoon PID reviewed & accepted ✅",
      "PCDS & all disclosures reviewed & accepted ✅",
      "Estoppel Certificate reviewed (if condo) ✅",
      "Buyer satisfies all conditions in writing — deal is now firm! 🎉",
    ],
    bg: IMAGES.house5,
  },
  {
    step: 11,
    emoji: "🗂️",
    title: "Conveyancing",
    subtitle: "Step 11 — File to Your Lawyer",
    bullets: [
      "Transfer of title documents drafted",
      "Mortgage discharge finalized",
      "Final numbers coordinated with buyer's lawyer",
    ],
    bg: IMAGES.house6,
  },
  {
    step: 12,
    emoji: "🎊",
    title: "POSSESSION DAY!",
    subtitle: "Step 12 — You're SOLD! 🔑",
    bullets: [
      "Buyer picks up the keys.",
      "Proceeds land in your account.",
      "What's your next chapter? DM me!",
    ],
    accent: "🥂 Congratulations — You're SOLD!",
    bg: IMAGES.keysHand,
  },
];
